import React from 'react';
import { Outlet, Route } from 'react-router-dom';
import { PERMISSIONS } from '../../../utils/permissions';
import BackofficeLayout, { BackofficeIndex } from './BackofficeLayout';
import ImportJobPage from './imports/ImportJobPage';
import ImportsPage from './imports/ImportsPage';
import MigrationGate from './migration/MigrationGate';
import MigrationPage from './migration/MigrationPage';
import MigrationRunPage from './migration/MigrationRunPage';
import PredictionImportsPage from './predictions/PredictionImportsPage';
import ProductsPage from './predictions/ProductsPage';
import { RequirePermission } from './RequirePermission';
import NewTaskPage from './tasks/new/NewTaskPage';
import TasksPage from './tasks/TasksPage';

/**
 * The backoffice's routes, under the signed-in layout: the routes are the access rules, so they live in one
 * place and their test renders them as they are.
 */
export function backofficeRoutes() {
  // any section's permission opens the backoffice; each route checks its own: tasks list:labelTask, a new task
  // create:labelTask, imports read:import, products and prediction imports read:prediction, the migration admin:migration
  return (
    <Route path="backoffice" element={<BackofficeLayout />}>
      <Route index element={<BackofficeIndex />} />
      <Route
        element={
          <RequirePermission permission={PERMISSIONS.READ_IMPORT}>
            <Outlet />
          </RequirePermission>
        }
      >
        <Route path="imports" element={<ImportsPage />} />
        <Route path="imports/:jobId" element={<ImportJobPage />} />
      </Route>
      <Route
        path="tasks"
        element={
          <RequirePermission permission={PERMISSIONS.LIST_LABEL_TASK}>
            <TasksPage />
          </RequirePermission>
        }
      />
      <Route
        path="tasks/new"
        element={
          <RequirePermission permission={PERMISSIONS.CREATE_LABEL_TASK}>
            <NewTaskPage />
          </RequirePermission>
        }
      />
      <Route
        path="products"
        element={
          <RequirePermission permission={PERMISSIONS.READ_PREDICTION}>
            <ProductsPage />
          </RequirePermission>
        }
      />
      <Route
        path="prediction-imports"
        element={
          <RequirePermission permission={PERMISSIONS.READ_PREDICTION}>
            <PredictionImportsPage />
          </RequirePermission>
        }
      />
      <Route path="migration" element={<MigrationGate />}>
        <Route index element={<MigrationPage />} />
        <Route path=":runId" element={<MigrationRunPage />} />
      </Route>
    </Route>
  );
}
